<template>
    <div class="roothome">

        <div class="wrapper">
            <div style="display: flex; justify-content: center;">

                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0">
                    <div class="head1">
                        <div style="width: 100%; text-align: left; height: 5vh; display: flex">
                            <img src="/static/imgs/ic_back_b.png" alt="menu" class="im_menu2" style="padding-left: 10%;" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                        </div>
                    </div>
                    <div class="head2">
                        <!-- ################    Title    ################# -->
                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full}, name: 'Home'}" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                            <img src="/static/imgs/advicep_horizontal.png" alt="logo advice" class="im40">
                        </router-link>
                    </div>
                    <div  class="head3">
                        <!--<div style="display: flex; height: 35%; width: 100%; align-items: center; justify-content: center;">-->
                            <!--<div class="bar_idiomas" @click="showDropDown('changeIdiomaSelect')">-->
                                <!--<img v-if="user.idioma==0" src="/static/imgs/ic_b_pt.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<img v-if="user.idioma==1" src="/static/imgs/ic_b_en.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<img v-if="user.idioma==2" src="/static/imgs/ic_b_es.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<span style="font-size: 2vh; color: black; margin-right: 7%;"> {{ getIdioma(user.idioma) }} </span>-->
                                <!--<select id="changeIdiomaSelect" @change="changeIdiomaSelector($event)" v-model="user.idioma" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 100%;">-->
                                    <!--<option value="0"> {{ getIdioma(0) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                    <!--<option value="1"> {{ getIdioma(1) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                    <!--<option value="2"> {{ getIdioma(2) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                <!--</select>-->
                            <!--</div>-->
                        <!--</div>-->

                        <div class="im_id_container">
                            <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                            <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                            <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                            <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                            <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                            <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                        </div>
                    </div>
                    <div  class="head4">
                        <div v-if="!user.sucess" style="display: flex; flex-direction: column; align-items: center">
                            <img @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'" src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile" style="height: 25%; margin-right: 0; margin-left: 0; margin-bottom: -15%;">

                            <span class="tx_login" style="margin-bottom: 1%; color: var(--gray-menu)" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.entrar) }}</span>

                            <!--<router-link to="registerUser">-->
                            <a href="/registerUser" >
                                <span class="tx_login2" >{{ getInterText(inter_ind.cadastre) }} </span>
                            </a>
                            <!--</router-link>-->
                        </div>
                        <div v-else @click="showPopEscritorio()" style="cursor: pointer;">
                            <div v-if='user.foto === ""' class="im_profile" style="text-align: center; padding-top: 1.2vh; background-color: var(--bg-blue)">
                                <span class="tx_initials" >{{ getInitials(user) }}</span>
                            </div>
                            <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile">
                            <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile">
                            <br>
                            <span class="tx_login5" >{{ getFirstAndLastWords(user.nome) }}</span>
                            <div style="width: 100%; display: flex; justify-content: center;">
                                <div class="triangle"></div>
                            </div>
                        </div>
                        <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                            <div class="arrow_top"></div>
                            <!--<span class="tx_login" >{{ user.nome }}</span>-->
                            <div style="display: flex; flex-direction: column; height: 15vh; justify-content: space-evenly;">
                                <router-link class="tx_login" to="MinhaPagina">
                                    <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                                </router-link>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('EditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ################    panorama e busca    ################# -->
                <div class="title4">



                    <div class="dv_title_desk">
                        <span class="tx_title_desk">{{ getInterText(inter_ind.editar_pagina) }}</span>
                        <span class="tx_form_whiteb_sub2">As informações com (*) são obrigatórias.</span>
                    </div>


                    <div class="dv_coluna_container">


                        <!-- ################    COLUNA ESQUERDA   ################# -->
                        <div class="dv_coluna_edit_register">
                            <div class="di_form_item" v-for="(item, index) in editing" v-if="index < 2">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index != 1" tabindex="1"/>
                                    <textarea :id="item.id" name="message" style="border: none; width: 100%; border-color: Transparent; overflow: auto; outline: none; font-size: 15pt; height: 300px;" rows="10" cols="30" v-model="item.texto" v-if="item.status && index == 1"></textarea>
                                </div>
                                <div v-html="displayFormattedText(item.texto)" v-if="!item.status && index == 1"></div>
                            </div>


                            <!--Video Link-->
                            <div class="di_form_item">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(14)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!editing[14].status">{{ editing[14].campo }}</span>
                                        <span class="tx_form" v-if="editing[14].status">{{ editing[14].campo }}</span>
                                    </div>
                                    <input :id="editing[14].id" class="input_name_m2" type="text" v-model="editing[14].texto" v-if="editing[14].status" tabindex="14"/>
                                </div>
                                <hr>
                                <div>
                                    <iframe v-if="isYouTubeLink(editing[14].texto)" width="100%" height="300" :src="'https://www.youtube.com/embed/' + getYoutubeCode(editing[14].texto)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                                    <!--<iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fadviceparaiba%2Fvideos%2F523508688327109%2F&show_text=false&width=560" width="100%" height="314" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>-->
                                </div>
                            </div>

                            <!-- ################    Categorias    ################# -->
                            <!--<div v-if="showCats_d" class="di_form_item_s"  @click="showCategorias()" onMouseOver="this.style.cursor='pointer'">-->
                            <div v-if="showCats_d" class="di_form_item_s">
                                <span class="tx_form_whiteb" >{{ getInterText(inter_ind.categorias) }}</span>
                                <span class="tx_form_whiteb_sub" > Permitido marcar até 3 categorias </span>
                            </div>
                            <div v-else class="di_form_item" @click="showCategorias()" onMouseOver="this.style.cursor='pointer'">
                                <span class="tx_form_grayb" >{{ getInterText(inter_ind.categorias) }}</span>
                            </div>
                            <div class="di_form_item_c" v-if="showCats_d" onMouseOver="this.style.cursor='pointer'">
                                <div class="di_form_item_c2" v-for="(item, index) in cats_full" v-if="(cats_full[index].apareceListagem || user.tipo >= 1) && index > 0" @click="selectCat(index)">

                                    <div class="di_form_item2_b" v-if="cats_full[index].deleted">
                                        <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min2">
                                        <span class="tx_form_white">{{ getInterCatName(item) }}</span>
                                    </div>
                                    <div class="di_form_item2" v-if="!cats_full[index].deleted">
                                        <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min2_gray">
                                        <span class="tx_form_gray">{{ getInterCatName(item) }}</span>
                                    </div>

                                </div>
                            </div>


                            <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 15 && hasSubCats()">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1"/>
                                </div>
                            </div>


                            <div style="display: flex; flex-direction: column; align-items: flex-start;">

                                <div v-if="(new_estab.id > 0) && (ativo == true)" style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-top: 2vh; margin-bottom: 2vh;" @click="setEstabAtivo()">
                                    <img src="/static/imgs/ic_option_off.png" alt="desativar" class="im_ic_option">
                                    <span style="font-size: 3.5vh; margin-left: 1vh; color: var(--font-dark-gray2); flex-grow: 5;">{{ getInterText(inter_ind.desativar_pagina) }}</span>
                                </div>

                                <div v-if="(new_estab.id > 0) && (ativo == false)" style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-top: 2vh; margin-bottom: 2vh;" @click="setEstabAtivo()">
                                    <img src="/static/imgs/ic_option_on.png" alt="ativar" class="im_ic_option">
                                    <span style="font-size: 3.5vh; margin-left: 1vh; color: var(--font-dark-gray2); flex-grow: 5;">{{ getInterText(inter_ind.ativar_pagina) }}</span>
                                </div>

                                <div v-if="new_estab.id > 0" style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-bottom: 2vh;" @click="submitformEstab(false)">
                                    <img src="/static/imgs/ic_excluir.png" alt="excluir" style="width: 3.3vh; height: 3vh; object-fit: contain">
                                    <span style="font-size: 3.5vh; margin-left: 1vh; color: var(--font-dark-gray2)">{{ getInterText(inter_ind.excluir_pagina) }}</span>
                                </div>

                            </div>


                        </div>



                        <!-- ################    COLUNA DIREITA   ################# -->
                        <div class="dv_coluna_edit_register">

                            <!-- ################    Fotos Estabelecimento   ################# -->
                            <span class="tx_form_whiteb_sub2" style="font-size: 3vh; color: var(--font-dark-gray2);"> {{ getInterText(inter_ind.inserir_foto) }}*</span>
                            <span class="tx_form_whiteb_sub2" style="font-size: 2.2vh"> Adicione até {{ qMaxFotos }} fotos</span>
                            <div id="photo_contain" style="display: flex; flex-direction: row; background-color: white; overflow-x: scroll; margin-bottom: 3vh">
                                <!--<input style="display: none" ref="inputImage" type="file" @change="onFileSelectedMany" multiple="multiple"/>-->
                                <input style="display: none" ref="inputImage" type="file" accept="image/*" @change="onFileSelectedMany" multiple/>
                                <div class="di_photo0" onMouseOver="this.style.cursor='pointer'" @click="$refs.inputImage.click()">
                                    <img src="/static/imgs/ic_camera.png" alt="profile" class="im_photos0">
                                    <span class="tx_inserir">{{ getInterText(inter_ind.inserir_foto) }}</span>
                                </div>
                                <!--Animação-->
                                <!--https://codepen.io/dslanger/pen/KqdvMO-->
                                <!--https://stackoverflow.com/questions/26807610/css-only-animate-draw-circle-with-border-radius-and-transparent-background-->
                                <div v-for="(item, index) in photos.slice().reverse()" class="di_photo">
                                    <div style="display: flex; position: relative;">
                                        <img v-if="!item.uploaded" src="/static/imgs/circle_insta3.png" alt="profile1" class="im_photos_back">
                                        <img v-else  :src="transpGif" alt="profile2" class="im_photos_back_s">

                                        <img v-if="item.data != null" :src="item.data" alt="profile3" class="im_photos">
                                        <img v-else :src="baseUrlImg + 'MARCADOR/' + item.file" alt="profile4" class="im_photos">

                                        <img src="/static/imgs/bt_erase.png" alt="profile" class="im_fechar" @click="removePhoto(photos.length - 1 - index)">
                                    </div>
                                    <div style="display: flex; justify-content: center; align-items: center; margin-top: 1vh;" @click="changeDestaque(index, 'photo_contain')">
                                        <input type="checkbox" :value="index" style="zoom: 1.3; margin-right: 3%; margin-top: 0;" :checked="item.destaque">
                                        <span style="font-size: 1.5vh">Destaque</span>
                                    </div>
                                </div>
                            </div>


                            <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 2">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}*</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}*</span>
                                    </div>
                                    <!--<input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1"/>-->
                                    <textarea :id="item.id" name="message" style="border: none; width: 100%; border-color: Transparent; overflow: auto; outline: none; font-size: 2.5vh" rows="2" cols="30" v-model="item.texto" v-if="item.status"></textarea>
                                    <!--<span v-if="!checkName(editing[0].texto) && editing[0].texto!=''" class="error_msg">Nome inválido.</span>-->
                                </div>
                            </div>

                            <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 3">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                        <img src="/static/imgs/loading4.gif" class="im_loading_cep" v-if="loadingCep">
                                        <span class="tx_form_small" @click="showAddress = !showAddress;" v-html="showAddress ? getInterText(inter_ind.esconder_endereco) : getInterText(inter_ind.digitar_endereco)"></span>
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1" v-on:keyup="verificaCEP(item.texto)"/>
                                    <span v-if="(item.texto.length >= 8) && item.texto!='' && !cepOk" class="error_msg">{{ getInterText(inter_ind.cep_nao) }}</span>
                                </div>
                            </div>

                            <div class="di_form_item" v-for="(item, index) in editing" v-if="showAddress && index >= 4 && index <= 9">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                        <img src="/static/imgs/loading4.gif" class="im_loading_cep" v-if="loadingCep">
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status" tabindex="1"/>
                                </div>
                            </div>


                            <div class="di_form_item" v-for="(item, index) in editing" v-if="index >= 10 && index <= 13 && (index != 12 || (hasCatsSiteVenda() && user.tipo >= 1))">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index == 10" tabindex="1" v-on:keyup="mphone(item)"/>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index != 10" tabindex="1"/>
                                    <span v-if="index == 13 && !checkEmail(item.texto) && item.texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                                </div>
                            </div>

                            <!-- ################    Ticket Medio    ################# -->
                            <div style="display: flex; flex-direction: column; padding-left: 5.5%; margin-top: 2vh; margin-bottom: 5vh;">
                                <div style="display: flex; align-items: left">
                                    <!--<span class="tx_form2">{{ getInterText(inter_ind.ticket_medio) }}</span>-->
                                    <span class="tx_form_whiteb_sub2" style="margin-left: 0; font-size: 3vh; color: var(--font-dark-gray2);">{{ getInterText(inter_ind.ticket_medio) }}</span>
                                </div>

                                <div style="display: flex; flex-direction: column;">
                                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">$20</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">&nbsp;</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">$40</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">&nbsp;</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">$60</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">&nbsp;</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">&nbsp;</span>
                                        </div>
                                        <div class="di_photo_ticket">
                                            <span class="tx_form3">$100+</span>
                                        </div>
                                    </div>
                                    <div style="display: flex; flex-direction: row; padding-right: 0px; justify-content: space-between">
                                        <div class="di_photo_ticket" @click="clickTicket(0)">
                                            <div class="di_circle" v-if="!ticket[0].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(1)">
                                            <div class="di_circle" v-if="!ticket[1].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(2)">
                                            <div class="di_circle" v-if="!ticket[2].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(3)">
                                            <div class="di_circle" v-if="!ticket[3].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(4)">
                                            <div class="di_circle" v-if="!ticket[4].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(5)">
                                            <div class="di_circle" v-if="!ticket[5].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(6)">
                                            <div class="di_circle" v-if="!ticket[6].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                        <div class="di_photo_ticket" @click="clickTicket(7)">
                                            <div class="di_circle" v-if="!ticket[7].status"/>
                                            <div class="di_circle_s" v-else/>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>

                    </div>




                    <!-- ################    Form    ################# -->
                    <div style="display: flex; flex-direction: column; margin-top: 2%;">



                    </div>

                    <!-- ################    TRAJE    ################# -->
                    <!--<div style="display: flex; flex-direction: row; padding-left: 5.5%;">-->
                    <!--<span class="tx_form2">{{ getInterText(inter_ind.traje) }}</span>-->
                    <!--<div style="display: flex; flex-direction: row;">-->
                    <!--<div class="di_photo_traje" @click="clickTraje(0)">-->
                    <!--<span class="tx_form3">{{ getInterText(traje[0].texto) }}</span>-->
                    <!--<div v-if="!traje[0].status" class="dv_traje2">-->
                    <!--<img src="/static/imgs/t_praia.png" alt="profile" class="im_traje2">-->
                    <!--</div>-->
                    <!--<div v-else class="dv_traje2_s">-->
                    <!--<img src="/static/imgs/t_praia.png" alt="profile" class="im_traje2_s">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="di_photo_traje" @click="clickTraje(1)">-->
                    <!--<span class="tx_form3">{{ getInterText(traje[1].texto) }}</span>-->
                    <!--<div v-if="!traje[1].status" class="dv_traje2">-->
                    <!--<img src="/static/imgs/t_sport.png" alt="profile" class="im_traje2">-->
                    <!--</div>-->
                    <!--<div v-else class="dv_traje2_s">-->
                    <!--<img src="/static/imgs/t_sport.png" alt="profile" class="im_traje2_s">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="di_photo_traje" @click="clickTraje(2)">-->
                    <!--<span class="tx_form3">{{ getInterText(traje[2].texto) }}</span>-->
                    <!--<div v-if="!traje[2].status" class="dv_traje2">-->
                    <!--<img src="/static/imgs/t_formal.png" alt="profile" class="im_traje2">-->
                    <!--</div>-->
                    <!--<div v-else class="dv_traje2_s">-->
                    <!--<img src="/static/imgs/t_formal.png" alt="profile" class="im_traje2_s">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->




                    <span v-for="item in msg_erros" class="error_msg" style="margin-left: 20px;"> * {{ item }} <br/> </span>




                    <!-- ################    Botao Enviar    ################# -->
                    <div style="width: 100%; margin-top: 2vh; margin-bottom: 5vh; margin-right: 5vw; display: flex; flex-direction: row; justify-content: center; align-items: center;">
                        <span class="tx_form_whiteb_sub2" style="margin-right: 0">Ao publicar você concorda e aceita nossos&nbsp;</span><a target="_blank" class="tx_form_whiteb_sub2" style="color: unset; margin-left: 0;" href="/static/pages/politicaprivacidade.html"> Termos de Uso e Privacidade</a>
                        <div style="padding: 1vh; padding-right: 5vh; padding-left: 5vh; background-color: var(--bg-purple); text-align: center; border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="submitformEstab(true)">
                            <span style="color: white; font-size: 25pt;">{{ getInterText(inter_ind.enviar) }}</span>
                        </div>
                    </div>












                </div>
            </div>


            <!--Barra de rodapé -->
            <div class="active">
                <div class="div_pat" v-if="cats.length!=0">
                    <span class="tx_parceiros">{{ getInterText(inter_ind.parceiros) }}</span><br>
                    <a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPath" class="im_pat"/></a>
                </div>
            </div>

        </div>


        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%; margin-right: -45vw;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_close_c.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>


                <div class="div_face_w" style="margin-top: 10vh;" @click="externalLoginFace_checkLoginState()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>
                    </div>
                </div>



                <div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>





                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" class="input_name_w" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>


                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar_w unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>

                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'registerUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" style="font-weight: normal;"> {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_cinza" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.058
                 0 0 0 0 0.384
                 0 0 0 0 0.674
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_white" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'

    export default {
        mixins: [advMixin],
        name: 'Home',
        data () {
            return {
                name: 'Home',
                ativo: true,
                estabs: [],
                cats: [],
                estabs_full: [],
                estabs_search: [],
                cats_full: [],
                quantCatsSelected: 0,
                idCat: 0,
                search_text: "",
                showingSearch: false ,
                showCats_d: true,
                cepOk: true,
                showAddress: false,
                response: {
                    status: "ok"
                },
                tituloCat: "Destaques",
                corCat: "#96989b",
                panoInd: 0,
                pano: [
                    {
                        imgPath: "static/imgs/pano_d_01.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_02.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_03.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_04.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_05.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_06.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_07.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_08.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_09.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                ],
                editing: [
                    {
                        id: 'zeroID',
                        campo: 'Nome da Página',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'umID',
                        campo: 'Descrição',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'doisID',
                        campo: 'Horário Funcionamento',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'tresID',
                        campo: 'CEP',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'quatroID',
                        campo: 'Rua',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'cincoID',
                        campo: 'Número',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'seisID',
                        campo: 'Complemento',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'seteID',
                        campo: 'Bairro',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'oitoID',
                        campo: 'Cidade',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'novoID',
                        campo: 'Estado',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'dezID',
                        campo: 'Telefone',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'onzeID',
                        campo: 'Web Site',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'dozeID',
                        campo: 'Site Venda',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'trezeID',
                        campo: 'E-mail',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'catorzeID',
                        campo: 'Link Vídeo',
                        texto: '',
                        status: false,
                    },
                    {
                        id: 'quinzeID',
                        campo: 'Sub-categoria',
                        texto: '',
                        status: false,
                    }
                ],
                ticket: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],
                msg_erros: [

                ],
                transpGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            }
        },
        methods: {
            setEstabAtivo() {
                this.ativo = !this.ativo;
                // console.log('ativo:: ', this.ativo);
            },
            getPanoImg() {
                return this.pano[this.panoInd].imgPath;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            closeKey() {
                console.log('closeKeyboard');
                this.$refs.search_i.blur();
            },
            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    try {
                        vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                    } catch (e) {
                        vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },
            getEstabsCats() {
                console.log('Entrei no getEstabsCats()');

                var url1 = this.baseUrlApi + 'estabelecimentos';
                var url2 = this.baseUrlApi + 'categorias';

                var vm = this;
                vm.loading.cats = true;
                vm.loading.estabs = true;

                axios.all([
                    axios.get(url1),
                    axios.get(url2),
                ])
                    .then(axios.spread(function(r1, r2) {
                        vm.estabs_full = r1.data;
                        vm.cats_full = r2.data;

                        //vm.dataj = Object.assign({}, vm.dataj, { estabs_full: r1.data, cats_full: r2.data });
                        //vm.$set(vm, 'dataj', { estabs_full: r1.data, cats_full: r2.data });

                        vm.adjustCaracterEncoding();

                        console.log('Estabelecimentos:');
                        console.log(vm.estabs_full);
                        console.log('Categorias:');
                        console.log(vm.cats_full);
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                        vm.atualizaParametros();
                    }))
                    .catch(function(error) {
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                        console.log('Error Catch' + error);
                    });
            },
            getEstabsSearch() {
                console.log('getEstabsSearch ' + this.search_text);

                this.estabs_search = [];

                this.cats = [
                    {
                        nome: this.inter_pt[this.inter_ind.resultado_busca],
                        nomeEn: this.inter_en[this.inter_ind.resultado_busca],
                        nomeEs: this.inter_es[this.inter_ind.resultado_busca],
                        id: -1
                    }
                ];




                if (this.search_text.length<3) {
                    console.log('getEstabsSearch::nao vou buscar');

                    if (this.search_text.length==0) {
                        this.cats = this.cats_full;
                    }
                    return ;
                }

                var search_text2 = this.search_text.toLowerCase();
                var i;
                for (i=0 ; i<this.estabs_full.length ; i++) {
                    var estab = this.estabs_full[i];

                    if (estab.nome.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.bairro.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.descricao2.toLowerCase().indexOf(search_text2)>=0) {
                        this.estabs_search.push(estab);
                        console.log('search: ' + estab.nome);
                    }
                    else {
                        var j;
                        for (j=0 ; j < estab.tbCategoriaEstabelecimentos.length ; j++) {
                            var catt = estab.tbCategoriaEstabelecimentos[j];
                            if (catt.nome.toLowerCase().indexOf(search_text2)>=0) {
                                this.estabs_search.push(estab);
                                console.log('search: ' + estab.nome);
                                break;
                            }
                        }
                    }
                }
            },
            getEstabs(idCat) {
                console.log('getEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
                                estabs.push(estab);
                            }
                        }
                    }
                }

                this.estabs = estabs;

                return estabs;
            },
            hasEstabs(idCat) {
                console.log('hasEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            },
            atualizaEstabs(idCatAtual) {
                console.log('atualizaEstabs id: ' + idCatAtual);
                var vm = this;

                if (idCatAtual==0) {
                    vm.cats = vm.cats_full;
                    console.log('cats:');
                    console.log(vm.cats);
                }
                else {
                    // vm.estabs = [];
                    vm.cats = [];

                    // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
                    var i;
                    for (i = 0; i < vm.cats_full.length; i++) {
                        var cat = vm.cats_full[i];
                        if (cat.id == idCatAtual) {
                            vm.tituloCat = cat.nome;
                            vm.corCat = cat.cor;
                            vm.idCat = cat.id;
                            vm.cats.push(cat);
                            break;
                        }
                    }
                }


                $('#sidebar').removeClass('active');
                $('.overlay').fadeOut();
                $('#icmenu').removeClass('open');
                // $('#div_pat_s').fadeOut(0);
            },
            atualizaParametros() {
                console.log('atualizaParametros');
                console.log(this.$route.query);

                if (this.$route.query.idCat == null) {
                    // this.tituloCat = "Destaques";
                    this.idCat = 0;
                    // this.corCat = "#96989b";
                    console.log('id eh nulo');
                } else {
                    this.idCat = this.$route.query.idCat;
                    console.log('id eh valido ' + this.idCat);
                }

                this.getCities();

                this.atualizaEstabs(this.idCat);
            },

            trimAll(str){
                return str.replace(/\s/g,'');
            },

            showCategorias() {
                this.showCats_d = !this.showCats_d;
            },
            displayFormattedText(text) {
                return text
                    .replace(/\n/g, '<br>')
                    .replace(/ /g, '&nbsp;');
            }
        },
        created() {
            console.log('created!!');


            this.new_estab.id = -1;

            this.editing[0].campo = this.getInterText(this.inter_ind.nome_pagina);
            this.editing[1].campo = this.getInterText(this.inter_ind.descricao);
            this.editing[2].campo = this.getInterText(this.inter_ind.horario_funcionamento);
            this.editing[3].campo = this.getInterText(this.inter_ind.cep);
            this.editing[4].campo = this.getInterText(this.inter_ind.rua);
            this.editing[5].campo = this.getInterText(this.inter_ind.numero);
            this.editing[6].campo = this.getInterText(this.inter_ind.complemento);
            this.editing[7].campo = this.getInterText(this.inter_ind.bairro);
            this.editing[8].campo = this.getInterText(this.inter_ind.cidade);
            this.editing[9].campo = this.getInterText(this.inter_ind.estado);
            this.editing[10].campo = this.getInterText(this.inter_ind.telefone);

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.stab) {
                    console.log('Usando new_estab passados por parametro!!');

                    this.new_estab = this.$route.params.stab;
                    console.log('new_estab: ', this.new_estab);

                    this.ativo = this.new_estab.ativo;

                    this.titlePage = this.getInterText(this.inter_ind.editar_pagina);

                    this.fillFieldsEstab(this.new_estab);
                }
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
            }

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            this.barra_pat = this.shuffle(this.barra_pat);

            this.initQuantCats();

            console.log('Terminei o mounted!!');
        },

    }



</script>


<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/advDesk.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        /*background-color: #f0f0f0;*/
        background-color: var(--main-bg-color);
        overflow-y: scroll;
    }
    .roothome::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .im_social {
        display: inline-block;
        /*width: 35px;*/
        /*width: 2.6vw;*/
        height: 90%;
        width: 100%;
        margin-top: 0.2vh;
        /*padding: 3px;*/
        object-fit: scale-down;
        /*padding: 0.1vw;*/
        vertical-align: middle;
    }
    .bar_idiomas {
        display: flex;
        vertical-align: middle;
        /*background-color: red;*/
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        /*background-size: auto 100%;*/
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 3.5vh;
    }

    .title4 {
        /*height: 275px;*/
        /*max-height: 275px;*/
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: var(--top-bar-heigth_desk);
        background-color: white;
    }

    .im_pat {
        height: 1.34cm;
        margin-left: 0.75cm;
        margin-right: 0.75cm;
        margin-bottom: 0.75cm;
        margin-top: 0.5cm;
        object-fit: contain;
    }
    .div_pat {
        position: page;
        bottom: 0;
        /*background-color: #949494;*/
        /*background-color: #C4C4C4;*/
        background-color: #CDCDCD;
        padding-top: 0.25cm;
        /*background-color: #E4E4E4;*/
        text-align: center;
    }
    .tx_parceiros {;
        font-size: 12pt;
        /*color: #040505;*/
        color: #858585;
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2vh;
        width: 100%;
        display: flex;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;

        display: flex;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;

        width: 90%;
        padding: 1.5vw;
        background: white;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        cursor: pointer;
    }

    .div_faceim {
        /*background: pink;*/
        display: flex;
        justify-content: center;
        flex-basis: 0;
        flex-grow: 1;
    }

    .im_face {
        /*background: red;*/
        display: flex;
        width: 3vh;
        height: 3vh;
        -webkit-filter: brightness(150%);
        filter: brightness(150%);
    }

    .div_facetx {
        /*background: brown;*/
        display: flex;
        justify-content: center;
        flex-grow: 1;
    }



    div_botao_t {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 5vh;
    }

    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
    }

    .tx_continuar {
        display: flex;
        flex-direction: row;
        font-weight: normal;
        color: unset;
        font-size: 2.5vh;
        /*font-family: 'Humanst521LTBT', Helvetica, Arial,sans-serif;*/
    }

    .im_loading_up {
        width: 50px;
        height: 50px;
    }

    .div_botao_t_w {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_t_w {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
        color: white;
        width: 80%;
    }

    .div_botao_t_w {
        border-style: none;
        background: white;
        padding: 1.3vh;
        height: 5vh;
        color: var(--bg-blue);
    }

    .div_botao_t {
        display: flex;
        align-items: center;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1.3vh;
        height: 5vh;
        color: white;
        cursor: pointer;
        width: 80%;
    }

    .div_botao_t:active {
        border-color: var(--bg-blue);
        background: white;
        color: var(--bg-blue);
    }

    .div_botao_t.tx_continuar:active {
        color: var(--bg-blue);
    }

    .custom-select-filtro {
        width: 60%;
        height: 4.5vh;
        background-color: var(--bg-blue-grad1);
        border-color: transparent;
        border-width: 1px;
        border-style: solid;
        text-align: center;

        margin-right: 2.5%;
        margin-left: 2.5%;
        margin-top: 1.5vh;
        margin-bottom: -1.5vh;

        display: flex;
    }

    select#sel_cats {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: red;*/
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    .hr_pat {
        width: 85%;
        margin-top: 0;
        margin-bottom: 5%;
        color: white;
        background-color: white;
        border-color: white;
    }


    .im_pat_m {
        /*background-color: #0f62ac;*/
        width: 85%;
        /*margin-right: 2%;*/
        /*margin-bottom: 2%;*/

    }

    .div_pat_m {
        position: page;
        bottom: 0;
        width: 100%;
        display: inline-block;
        /*background-color: #CDCDCD;*/
        padding-top: 0;
        /*padding-bottom: 0.5cm;*/
        text-align: center;
        /*font-size: 0;*/
    }


    .div_pat_m {
        background-color: transparent;
        /*background-color: pink;*/
        /*background-color: #0171bb;*/
        /*position: fixed;*/
        /*bottom: 0;*/
        width: 100%;
        height: 6%;
        /*display: inline-block;*/
        /*margin-bottom: 5vh;*/
    }

    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }


    /****************** Login window *****************/
    .div_login_m {
        /*background: rgba(1, 0, 0, .7);*/
        /*background: blue;*/
        flex-direction: column;
        display: flex;
        justify-content: center;
        position: fixed;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow-x: auto;
        overflow-y: auto;
        z-index: 1000;
    }

    .parts_m {
        background-color: blue;
        background-image: url('/static/imgs/bg_login.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        /*background: red;*/
        /*box-shadow: 5px 5px 5px black;*/
        width: 100vw;
        height: 100vh;
        /*height: max-content;*/
        display: flex;
        padding: 8vw;
        padding-top: 1vw;
        align-items: center;
        overflow-y: auto;
        flex-direction: column;
        padding-right: 30vw;
        padding-left: 30vw;
    }

    .im_close_w {
        display: flex;
        justify-self: flex-end;
        width: 30px;
        height: 30px;
        margin-right: -6vw;
        margin-top: 0;
        cursor: pointer;
    }

    .im_close_w {
        filter: brightness(0%) invert(100%);
        -webkit-filter: brightness(0%) invert(100%);
    }

    .tx_nome_before_w, .tx_nome_w {
        display: flex;
        width: 100%;
        font-size: 25pt;
        /*color: gray;*/
    }

    .tx_nome_w {
        color: white;
        font-size: 3vh;
    }

    .tx_nome_before_w {
        color: white;
        font-family: 'Humanst521BT';
        font-size: 3vh;
    }

    .hr_w {
        width: 100%;
        height: 2px;
        margin-top: 5px;
        background: gray;
    }

    .hr_w {
        background-color: white;
    }

    .error_msg {
        font-family: 'Humanst521BT';
        color: red;
        font-size: 2.5vh;
    }

    .div_check {
        display: flex;
        width: 100%;
        margin-top: 0;
        align-items: center;
    }

    .div_check_in {
        display: flex;
        border-width: 2px;
        border-style: solid;
        border-color: white;
        width: 15px !important;
        height: 15px !important;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        cursor: pointer;
    }

    .tx_checkbox {
        color: white;
        font-weight: bold;
        margin-top: -4px;
    }

    .tx_check {
        color: white;
        font-style: normal;
        text-align: center;
        display: flex;

        font-weight: normal;
        display: flex;
        font-size: 9pt;
        font-size: 2.5vh;
        margin-left: 1.5vw;

        justify-items: flex-end;
        align-content: flex-end;
        alignment-baseline: bottom;
    }

    .div_botao_login {
        border-style: solid;
        border-color: white;
        border-width: 1px;
        width: 15vw;
        height: 5vh;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        /*background: white;*/

        color: white;
    }

</style>



// WEBPACK FOOTER //
// src/components/RegisterEstab.vue